import { AppBar, Box, Button, Drawer, IconButton, Toolbar, Typography } from "@mui/material";
import palette from "../theme/palette";
import Logo from "../components/Logo";
import SearchBar from "../components/SearchBar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MenuOutlined, Search } from "@mui/icons-material";
import { useEffect, useState } from "react";
import ProductCard from "../components/downloads-page/ProductCard";

export default function NavBar({ onOpenSidebar }) {
  let { productCategory, productLine, product, version } = useParams()

  const navigate = useNavigate()

  const [results, setResults] = useState([])
  const [openDrawer, setOpenDrawer] = useState(false)

  const [initialSearch, setInitialSearch] = useState(true);

  const handleDrawer = () => {
    if (openDrawer) {
      setOpenDrawer(false);
      setInitialSearch(true);
    }
    else {
      setOpenDrawer(true);
    }
  }

  useEffect(() => {
    if (openDrawer) {
      handleDrawer();
    }
  }, [productCategory, productLine, product])

  useEffect(() => {
    if (results.length > 0) {
      setInitialSearch(false)
    }
  }, [results])

  return (
    <Box
      sx={{
        display: 'flex'
      }}
    >
      <AppBar
        position="fixed"
        sx={{
          bgcolor: palette.primary.main,
          zIndex: 1399
        }}
        component={'nav'}
      >
        <Toolbar>
          <Box
            onClick={() => navigate('/')}
            sx={{
              mr: 2,
              cursor: 'pointer'
            }}
          >
            <Logo />
          </Box>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{
              display: {
                xs: 'block',
                sm: 'none'
              },
              mr: 2
            }}
            onClick={onOpenSidebar}
          >
            <MenuOutlined />
          </IconButton>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <Button
              sx={{ color: '#fff' }}
              component={Link}
              to={'/downloads'}
            >
              Downloads
            </Button>
            {/* <Button
            sx={{ color: '#fff' }}
            component={Link}
            to={'/knowledgebase'}
          >
            Knowledgebase
          </Button>
          <Button
            sx={{ color: '#fff' }}
            component={Link}
            to={'/tickets'}
          >
            Tickets
          </Button> */}
            <Button
              sx={{ color: '#fff' }}
              component={Link}
              to={'https://avidid.com/message'}
              target={'_blank'}
            >
              Contact Us
            </Button>
          </Box>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          </Typography>
          <Button
            sx={{ color: '#fff' }}
            onClick={handleDrawer}
            startIcon={<Search />}
          >
            Search
          </Button>
        </Toolbar>
      </AppBar>
      <Drawer
        open={openDrawer}
        anchor={'top'}
        onClose={handleDrawer}
        sx={{
          overflow: 'scroll'
        }}
        disableRestoreFocus
      >
        <Box
          sx={{
            padding: 1,
          }}
        >
          <Toolbar />
          <SearchBar setResults={setResults} />
          {
            !initialSearch &&
            <Box
              direction={'row'}
              spacing={1}
              sx={{
                padding: 1,
                overflow: 'auto',
                display: 'flex',
                '&>*': {
                  marginRight: 1
                }
              }}
            >
              {
                results.length > 0 ?
                  results.map(item => {
                    return (
                      <ProductCard
                        key={item.id}
                        title={item.title}
                        path={[
                          item.productline.productcategory.title,
                          item.productline.title,
                          item.productid
                        ]}
                        images={item.image}
                      />
                    )
                  })
                  :
                  <Box
                    sx={{
                      height: '200px',
                      width: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <Typography
                      variant="h6"
                    >
                      No Results Found
                    </Typography>
                  </Box>
              }
            </Box>
          }
        </Box>
      </Drawer>
    </Box>
  )
}